var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"app-button",class:_vm.type,attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.callback($event)}}},[(_vm.isLoading)?_c('i',{staticClass:"fa fa-spinner fa-pulse fa-fw"}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }